define('modules/static-data-fetcher/js/config/static-data-config',['require'],function (require) {
    "use strict";
    return {
        "companyStatusV2": [{
                label: "Operating",
                id: "operating"
            }, {
                label: "Acquired",
                id: "acquired"
            }, {
                label: "Liquidating",
                id: "liquidating"
            }, {
                label: "Non-Operating",
                id: "non-operating"
            }, {
                label: "Out of Business",
                id: "outofbusiness"
            }
        ],
        "businessStructure": [{
                label: "Global Parent",
                id: "Global Parent"
            }, {
                label: "Subsidiary",
                id: "Subsidiary"
            }, {
                label: "Independent",
                id: "Independent"
            }, {
                label: "Holding",
                id: "Holding"
            }, {
                label: "Branch",
                id: "Branch"
            }, {
                label: "Uncategorized",
                id: "Uncategorized"
            }       
        ],
        "businessStructureFieldIds": [
            "Uncategorized",
            "Global Parent",
            "Subsidiary",
            "Group",
            "Branch",
            "Independent"
        ],
        "contactInfo": [{
            label : "Email",
            id : "Email",
            emailValidationStatus: [{
                label: "Valid Email",
                id: "ValidEmail"
            }, {
                label: "Valid Domain",
                id: "ValidDomain"
            }]
        },
        {
            label : "Desk Phone",
            id : "DIRECT_PHONE"
        },
        {
            label : "Mobile Phone",
            id : "MOBILE_PHONE"
        },
        {
            label : "Corporate Phone",
            id : "CORPORATE_PHONE"
        }],
        "companyTypeV2": [{
                label: "Public",
                id: "public"
            }, {
                label: "Private",
                id: "private"
            }, {
                label: "Government",
                id: "government"
            },{
                label: "Organization",
                id: "organization"
            }
        ],
        "contactSocialNetworks": [
            "LinkedIn",
            //"Facebook",
            "Twitter"
        ],
        "fiscalYearEnd": [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        "regions": [
            "Asia",
            "Europe",
            "Africa",
            "South America",
            "Middle East",
            "North America",
            "Oceania"
        ],
        "siteStatus" : [{
            label : "Out Of Business",
            id : "OutOfBusiness"
        },
        {
            label : "Operating",
            id : "Operating"
        }],
        "connectionTypes": [{
            label : "People you know",
            id : "PERSONAL"
        },{
            label : "People your coworkers know",
            id : "PEOPLE_YOUR_COWORKERS_KNOW"
        },{
            label : "Your employer",
            id : "COWORKERS"
        },{
            label : "Previous employers",
            id : "PREVIOUS_COWORKERS"
        },{
            label : "Your coworker's previous employers",
            id : "PREVIOUS_TEAM_COWORKERS"
        },{
            label : "Reference customers",
            id : "REFERENCE_CUSTOMERS"
        },{
            label : "Alumni",
            id : "EDUCATION"
        }],
        "intentDurationAPIkeyMapping": [{
            id: "WEEK1",
            label : "Last Week"
        },{
            id: "WEEK2",
            label : "Last 2 Weeks"
        },{
            id: "WEEK4",
            label : "Last Month"
        },{
            id: "WEEK12",
            label : "Last 3 Months"
        }]
    };
});
